module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.assembledClass,
    attrs: {
      "type": _vm.buttonType
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40630535"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/button.vue
// module id = 1219
// module chunks = 1